import * as companyPolicy from "../../types/admin/companyPolicyTypes";

//Get All Company Policy
export const getCompanyPolicyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyPolicy.GET_COMPANY_POLICY_REQUEST:
      return {
        ...state,
        getCompanyPolicyLoading: true,
      };
    case companyPolicy.GET_COMPANY_POLICY_SUCCESS:
      return {
        ...state,
        getCompanyPolicyLoading: false,
        getCompanyPolicyInfo: payload,
        getCompanyPolicyError: "",
      };
    case companyPolicy.GET_COMPANY_POLICY_FAIL:
      return {
        ...state,
        getCompanyPolicyLoading: false,
        getCompanyPolicyInfo: [],
        getCompanyPolicyError: payload,
      };
    default:
      return state;
  }
};

//Create Company Policy
export const createCompanyPolicyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyPolicy.CREATE_COMPANY_POLICY_REQUEST:
      return {
        ...state,
        createCompanyPolicyLoading: true,
      };
    case companyPolicy.CREATE_COMPANY_POLICY_SUCCESS:
      return {
        ...state,
        createCompanyPolicyLoading: false,
        createCompanyPolicyInfo: payload,
        createCompanyPolicyError: "",
      };
    case companyPolicy.CREATE_COMPANY_POLICY_FAIL:
      return {
        ...state,
        createCompanyPolicyLoading: false,
        createCompanyPolicyInfo: [],
        createCompanyPolicyError: payload,
      };
    default:
      return state;
  }
};

//Update Company Policy
export const updateCompanyPolicyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyPolicy.UPDATE_COMPANY_POLICY_REQUEST:
      return {
        ...state,
        updateCompanyPolicyLoading: true,
      };
    case companyPolicy.UPDATE_COMPANY_POLICY_SUCCESS:
      return {
        ...state,
        updateCompanyPolicyLoading: false,
        updateCompanyPolicyInfo: payload,
        updateCompanyPolicyError: "",
      };
    case companyPolicy.UPDATE_COMPANY_POLICY_FAIL:
      return {
        ...state,
        updateCompanyPolicyLoading: false,
        updateCompanyPolicyInfo: [],
        updateCompanyPolicyError: payload,
      };
    default:
      return state;
  }
};

// Delete Company Policy
export const deleteCompanyPolicyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyPolicy.DELETE_COMPANY_POLICY_REQUEST:
      return {
        ...state,
        deleteCompanyPolicyLoading: true,
      };
    case companyPolicy.DELETE_COMPANY_POLICY_SUCCESS:
      return {
        ...state,
        deleteCompanyPolicyLoading: false,
        deleteCompanyPolicyInfo: payload,
        deleteCompanyPolicyError: "",
      };
    case companyPolicy.DELETE_COMPANY_POLICY_FAIL:
      return {
        ...state,
        deleteCompanyPolicyLoading: false,
        deleteCompanyPolicyInfo: [],
        deleteCompanyPolicyError: payload,
      };
    default:
      return state;
  }
};
export const deleteCompanyPolicyDocReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case companyPolicy.DELETE_COMPANY_POLICY_DOCUMENT_REQUEST:
      return {
        ...state,
        deleteCompanyPolicyLoading: true,
      };
    case companyPolicy.DELETE_COMPANY_POLICY_DOCUMENT_SUCCESS:
      return {
        ...state,
        deleteCompanyPolicyLoading: false,
        deleteCompanyPolicyInfo: payload,
        deleteCompanyPolicyError: "",
      };
    case companyPolicy.DELETE_COMPANY_POLICY_DOCUMENT_FAIL:
      return {
        ...state,
        deleteCompanyPolicyLoading: false,
        deleteCompanyPolicyInfo: [],
        deleteCompanyPolicyError: payload,
      };
    default:
      return state;
  }
};
